import type { LinkType } from './smart-link.types';

/**
 * Classify a URL into a LinkType.
 *
 * Pure function with no React/DOM dependency. It lives in its own module
 * (NOT 'use client') on purpose: it used to sit inside smart-link.tsx, which
 * is a Client Component, so importing it from a Server Component failed
 * ("cannot call a client function from the server"). Here it is usable from
 * both server and client.
 */
export function getLinkType(url: string): LinkType {
  if (url.startsWith('mailto:')) return 'mailto';
  if (url.startsWith('tel:')) return 'tel';
  if (url.startsWith('http://') || url.startsWith('https://')) return 'external';
  return 'internal';
}
